export function execCopy({ selector }) {
  // 選択用のタグ生成
  const text = document.querySelector(selector);

  // クリップボードにコピー
  navigator.clipboard.writeText(text.value).then(error => {
    Raven.captureException(error);
  });

  window.getSelection().removeAllRanges();
}
